import React from 'react'

import { ReactComponent as OperationFIVG } from '../assets/svg/Header/OperationFIVG.svg'
import { ReactComponent as OperationBORM } from '../assets/svg/Header/OperationBORM.svg'
import { ReactComponent as OperationBCSH } from '../assets/svg/Header/OperationBCSH.svg'

export const SUPPLIERS_LIST = [
  {
    permission: true,
    link: 'gama',
    name: `Cuarta (IV) gama`,
    icon: <OperationFIVG width={'30px'} height={'30px'} />,
    enabled: true,
    disabled: false,
    tradeName: 'FIVG',
  },
  {
    permission: true,
    link: 'cocktailshop',
    name: `Cocktailshop`,
    icon: <OperationBCSH width={'30px'} height={'30px'} />,
    enabled: true,
    disabled: false,
    tradeName: 'B-CSH',
  },
  {
    permission: true,
    link: 'oriental',
    name: `Oriental Market`,
    icon: <OperationBORM width={'30px'} height={'30px'} />,
    enabled: true,
    disabled: false,
    tradeName: 'B-ORM',
  },
]
